// eslint-disable-next-line
import ko from 'imports-loader?additionalCode=var%20define%20%3D%20false%3B!knockout/build/output/knockout-latest';

window.ko = ko;
